var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLandPlot1855(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1920,
    height: 1080,
    viewBox: "0 0 1920 1080",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M716.131 539.828L698.252 539.943L700.429 515.415L718.08 515.186L716.131 539.828Z",
    stroke: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLandPlot1855);
export default __webpack_public_path__ + "static/media/land_plot_1855.24a1687e520ae513f43904d4b809d377.svg";
export { ForwardRef as ReactComponent };